var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxTfPredictive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.69 86.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tx_TFPredictive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.42,39a5.9,5.9,0,1,1-5.9,5.9A5.9,5.9,0,0,1,49.42,39Zm-2.14,5.9a2.14,2.14,0,1,0,2.14-2.14A2.14,2.14,0,0,0,47.28,44.86Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.79,39a5.9,5.9,0,1,1-5.9,5.9A5.9,5.9,0,0,1,79.79,39Zm-2.14,5.9a2.14,2.14,0,1,0,2.14-2.14A2.14,2.14,0,0,0,77.65,44.86Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.3,32.13H83.8l-7.64-7.39a4,4,0,0,0-2.75-1.11l-9.08-.06a10.5,10.5,0,0,0-6.93,2.58l-6.88,6H44.45A7.42,7.42,0,0,0,37,39.47L37,44.81a2,2,0,0,0,2,2h2.21a8.67,8.67,0,0,1-.24-2,8.47,8.47,0,0,1,16.94,0,8.67,8.67,0,0,1-.24,2H71.56a8.67,8.67,0,0,1-.24-2,8.47,8.47,0,1,1,16.94,0A8.14,8.14,0,0,1,88,46.78h1.61a2,2,0,0,0,2-2V36.48A4.35,4.35,0,0,0,87.3,32.13Zm-8.54,0H70.85l-.17,0-14.78,0a.81.81,0,0,1-.53-1.43l2.81-2.44a10.52,10.52,0,0,1,7-2.58l7.41.05a4,4,0,0,1,2.75,1.12l4,3.88A.81.81,0,0,1,78.76,32.13Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.3,39a5.9,5.9,0,1,1-5.89,5.9A5.9,5.9,0,0,1,108.3,39Zm-2.13,5.9a2.14,2.14,0,1,0,2.13-2.14A2.13,2.13,0,0,0,106.17,44.86Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.6,39a5.9,5.9,0,1,1-5.9,5.9A5.9,5.9,0,0,1,20.6,39Zm-2.14,5.9a2.14,2.14,0,1,0,2.14-2.14A2.14,2.14,0,0,0,18.46,44.86Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.58,101.89a8.4,8.4,0,1,1-8.4-8.4A8.39,8.39,0,0,1,110.58,101.89Zm-8.4-3a3,3,0,1,0,3,3A3,3,0,0,0,102.18,98.85Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.34,101.89A8.4,8.4,0,1,1,59,93.49,8.39,8.39,0,0,1,67.34,101.89Zm-8.39-3a3,3,0,1,0,3,3A3,3,0,0,0,59,98.85Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.83,94.22a10.58,10.58,0,0,0-10.57-10.46h-8.64l-9.8-8.51A15,15,0,0,0,81,71.58L68,71.66a5.65,5.65,0,0,0-3.91,1.59L53.23,83.76h-5A6.19,6.19,0,0,0,42.07,90v11.8a2.86,2.86,0,0,0,2.85,2.86h2.29a11.73,11.73,0,0,1-.33-2.73,12.07,12.07,0,0,1,24.13,0,11.9,11.9,0,0,1-.35,2.82H90.47a11.9,11.9,0,0,1-.35-2.82,12.06,12.06,0,1,1,24.12,0,12.44,12.44,0,0,1-.34,2.82H117a2.87,2.87,0,0,0,2.87-2.89ZM93,83.76l-21,0-.24,0H60.41a1.15,1.15,0,0,1-.8-2l5.73-5.54a5.7,5.7,0,0,1,3.91-1.59l10.56-.06a14.9,14.9,0,0,1,9.9,3.66l4,3.48A1.16,1.16,0,0,1,93,83.76Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.76,70.69H39.64a2,2,0,0,1,0-4H55.76a2,2,0,0,1,0,4Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.11,80.17h-36a2,2,0,0,1,0-4H45.11a2,2,0,0,1,0,4Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.77,91H16.11a2,2,0,0,1,0-4H32.77a2,2,0,0,1,0,4Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.25,102.63H21.78a2,2,0,0,1,0-4H32.25a2,2,0,0,1,0,4Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.69,46.85V32.12h-13.9a.81.81,0,0,1-.54-1.43l2.82-2.44a10.5,10.5,0,0,1,7-2.58l4.67,0v-2.1l-5.48,0a10.51,10.51,0,0,0-6.93,2.58l-6.88,6h-6.07a7.42,7.42,0,0,0-7.42,7.34l-.06,5.34a2,2,0,0,0,2,2h2.2a8.67,8.67,0,0,1-.24-2,8.48,8.48,0,0,1,17,0,8.16,8.16,0,0,1-.25,2Z",
    transform: "translate(0 -23.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.11,32.13h-3.5L17,24.74a4,4,0,0,0-2.74-1.11l-9.09-.06A10.41,10.41,0,0,0,0,24.9v2.59a10.52,10.52,0,0,1,5.94-1.81l7.42.05a4,4,0,0,1,2.75,1.12l4,3.88a.81.81,0,0,1-.56,1.4H11.66l-.17,0L0,32.13V46.85H12.37a8.16,8.16,0,0,1-.25-2,8.48,8.48,0,0,1,17,0,8.7,8.7,0,0,1-.23,1.92h1.61a2,2,0,0,0,2-2V36.48A4.34,4.34,0,0,0,28.11,32.13Z",
    transform: "translate(0 -23.57)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxTfPredictive);
export default __webpack_public_path__ + "static/media/tx_TFPredictive.61a9fc057f92a6e526c3f8cecabcf146.svg";
export { ForwardRef as ReactComponent };